"use client";

import { useMemo, type ReactNode } from "react";
import { createLoggerClient } from "./createLoggerClient";
import { LoggingProvider as Logging } from "cy-logging/react";
import { configureProductionNotifications } from "cy-fe";

const notificationsLogger = createLoggerClient("notifications");

configureProductionNotifications((message, context, error) => {
  notificationsLogger.error(message, context, error);
});

export function LoggingProvider({ children }: { children: ReactNode }) {
  const logger = useMemo(() => createLoggerClient(), []);
  return <Logging logger={logger}>{children}</Logging>;
}
